import React from 'react';
import PropTypes from 'prop-types';
import Chip from '@mui/material/Chip';
import Tooltip from '@mui/material/Tooltip';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { getDuplicateExplanation } from '../../utils/scanReportUtils';

/**
 * DuplicateBadge renders a subtle informational chip indicating a document is a duplicate.
 * Hovering shows a tooltip explaining the duplicate reason (CONTENT_MATCH vs HASH_MATCH).
 *
 * Returns null if not a duplicate (no reason provided).
 *
 * @param {Object} props
 * @param {string} [props.duplicateReason] - Duplicate reason code
 * @param {string} [props.size] - MUI Chip size
 * @param {Object} [props.sx] - Additional MUI sx styles
 */
const DuplicateBadge = ({ duplicateReason, size = 'small', sx = {}, ...rest }) => {
  if (!duplicateReason) return null;

  const explanation = getDuplicateExplanation(duplicateReason);

  return (
    <Tooltip title={explanation} arrow placement="top">
      <Chip
        icon={<ContentCopyIcon fontSize="small" />}
        label="Duplicate"
        size={size}
        variant="outlined"
        color="info"
        sx={{
          fontWeight: 500,
          borderStyle: 'dashed',
          ...sx,
        }}
        {...rest}
      />
    </Tooltip>
  );
};

DuplicateBadge.propTypes = {
  duplicateReason: PropTypes.string,
  size: PropTypes.oneOf(['small', 'medium']),
  sx: PropTypes.object,
};

export default DuplicateBadge;